<template>
    <div class="h-16 w-16">
        <svg
            v-if="glyph === StorefrontIconGlyph.SHOPPING_BAG"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
        >
            <!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
            <path
                fill="currentColor"
                d="M352 160v-32C352 57.4 294.6 0 224 0 153.4 0 96 57.4 96 128v32H0v272c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V160h-96zm-192-32c0-35.3 28.7-64 64-64s64 28.7 64 64v32H160v-32zm160 120c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm-192 0c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
            />
        </svg>

        <svg
            v-else-if="glyph === StorefrontIconGlyph.MOUNTAIN"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 512"
        >
            <!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
            <path
                fill="currentColor"
                d="M634.9 462.7l-288-448C341 5.5 330.9 0 320 0s-21 5.5-26.9 14.7l-288 448a32 32 0 0 0 -1.2 32.6A32 32 0 0 0 32 512h576c11.7 0 22.5-6.4 28.1-16.7a32 32 0 0 0 -1.2-32.6zM320 91.2L405.4 224H320l-64 64-38.1-38.1L320 91.2z"
            />
        </svg>

        <svg
            v-else-if="glyph === StorefrontIconGlyph.PERSON"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 384 512"
        >
            <!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
            <path
                fill="currentColor"
                d="M120 72c0-39.8 32.2-72 72-72s72 32.2 72 72c0 39.8-32.2 72-72 72s-72-32.2-72-72zm254.6 1.4c-12.5-12.5-32.8-12.5-45.3 0L242.7 160H141.3L54.6 73.4c-12.5-12.5-32.8-12.5-45.3 0-12.5 12.5-12.5 32.8 0 45.3L104 213.3V480c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V368h16v112c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V213.3l94.6-94.6c12.5-12.5 12.5-32.8 0-45.3z"
            />
        </svg>
    </div>
</template>

<script setup lang="ts">
import { StorefrontIconGlyph } from '~/resources/scalars/storefront-catalog-scalar'

defineProps<{ glyph: StorefrontIconGlyph }>()
</script>
